const vertifyManagement = () => import ('@/pages/security/vertify/vertify-management')
const updateoi = () => import ('@/pages/security/vertify/updateoi')
const queryoi = () => import ('@/pages/security/vertify/queryoi')
const main = () => import ('@/pages/security/main/main')
const vertify = () => import ('@/pages/security/vertify/vertify')
const operatorModify = () => import ('@/pages/security/vertify/operator-modify')
const pswdModify = () => import ('@/pages/security/main/pswd-modify')
const txnpswdModify = () => import ('@/pages/security/main/txnpswd-modify')
const mobileModify  = () => import ('@/pages/security/main/mobile-modify')
const emailModify = () => import ('@/pages/security/main/email-modify')
const personalAuthentication = () => import ('@/pages/security/personalAuthentication/index')
const editPersonalInfo = () => import ('@/pages/security/personalAuthentication/editPage')
export default [
    {
        path:'security/personalAuthentication',
        name:'PersonalAuthentication',
        component: personalAuthentication
    },
    {
        path:'security/editPersonalInfo',
        name:'EditPersonalInfo',
        component: editPersonalInfo
    },
    {
        path:'security/vertify-management',
        name:'security/vertify-management',
        component: vertifyManagement
    },
    {
        path:'security/updateoi',
        name:'security/updateoi',
        component: updateoi
    },
    {
        path:'security/queryoi',
        name:'security/queryoi',
        component: queryoi
    },
    {
        path:'security/main',
        name:'security/main',
        component: main
    },
    {
        path:'security/vertify',
        name:'security/vertify',
        component: vertify
    },
    {
        path:'security/operator-modify',
        name:'security/operator-modify',
        component: operatorModify
    },
    {
        path:'security/pswd-modify',
        name:'security/pswd-modify',
        component: pswdModify
    },
    {
        path:'security/txnpswd-modify',
        name:'security/txnpswd-modify',
        component: txnpswdModify
    },
    {
        path:'security/mobile-modify',
        name:'security/mobile-modify',
        component: mobileModify
        
    },
    {
        path:'security/email-modify',
        name:'security/email-modify',
        component: emailModify
        
    }
    
]


// WEBPACK FOOTER //
// ./src/router/security.js